import { createFileRoute } from '@tanstack/react-router'

import { PageLayout } from '@/components/layout'

import { productCategoryApi } from '@/features/product/api/product-category-api'
import { CategoryForm } from '@/features/product/components/product-category-form'

export const Route = createFileRoute('/_app/product/category/$id/update')({
  loader: async ({ context, params }) => {
    const { id } = params
    const {
      data: { category },
    } = await context.qc.ensureQueryData(productCategoryApi.detail.query({ params: { id } }))

    return {
      crumb: category.name,
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()

  return (
    <PageLayout>
      <CategoryForm
        mode='update'
        id={id}
        onBack={() => navigate({ to: '/product/category', replace: true })}
      />
    </PageLayout>
  )
}
